/** Inclusive ISO date range → YYYY-MM-DD list */
export function eachDay(start: string, end: string): string[] {
  if (!start || !end) return []
  const out: string[] = []
  const cur = new Date(start + 'T12:00:00')
  const last = new Date(end + 'T12:00:00')
  if (Number.isNaN(cur.getTime()) || Number.isNaN(last.getTime())) return []
  if (cur > last) return []
  while (cur <= last) {
    out.push(cur.toISOString().slice(0, 10))
    cur.setDate(cur.getDate() + 1)
  }
  return out
}

/** Expand trip window by pad days on each side for availability picking */
export function availabilityWindow(start: string, end: string, pad = 2): string[] {
  if (!start || !end) return []
  const s = new Date(start + 'T12:00:00')
  const e = new Date(end + 'T12:00:00')
  if (Number.isNaN(s.getTime()) || Number.isNaN(e.getTime())) return []
  s.setDate(s.getDate() - pad)
  e.setDate(e.getDate() + pad)
  return eachDay(s.toISOString().slice(0, 10), e.toISOString().slice(0, 10))
}

export function formatDayShort(iso: string): string {
  const d = new Date(iso + 'T12:00:00')
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' })
}

export function toggleDate(list: string[], day: string): string[] {
  return list.includes(day) ? list.filter((d) => d !== day) : [...list, day].sort()
}
